// @core/api/endpoints/authn/verify_password.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  VerifyPasswordRequest,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Verify password for sensitive action
 * Validates the user's current password before performing sensitive operations. Used as a security check for actions like deleting account or changing security settings.
 */
export async function VerifyPassword(
  data: VerifyPasswordRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/auth/password/verify`;
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
